/**
 * Переиспользуемые стили для модальных окон
 */

export const MODAL_STYLES = {
  // Контейнер модального окна (по центру)
  overlay:
    "fixed inset-0 bg-black/70 flex items-center justify-center z-[60] p-4",

  // Контейнер модального окна (снизу)
  bottomOverlay:
    "fixed bottom-0 left-0 right-0 flex items-end justify-center z-50 p-4 pointer-events-none",

  // Основной контейнер модала (по центру)
  modal:
    "relative w-full max-w-lg bg-amber-100 rounded-xl border-4 border-amber-800 shadow-2xl",

  // Основной контейнер модала (снизу)
  bottomModal:
    "w-full max-w-xl mb-4 sm:mb-8 pointer-events-auto bg-amber-100 rounded-xl border-4 border-amber-800 shadow-2xl",

  // Внутренний контейнер контента
  content: "px-8 py-8 sm:px-12 sm:py-10",

  // Большой контент (для правил и прочего)
  contentLarge: "px-8 py-8 sm:px-12 sm:py-10 max-w-3xl",

  // Заголовок модального окна
  title: "text-xl sm:text-2xl font-bold text-amber-900 mb-6 text-center",

  // Основная кнопка (ОК, Закрыть, Применить)
  button:
    "px-3 py-1.5 bg-gradient-to-b from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white font-bold rounded-none border-2 border-amber-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.3),inset_0_-1px_0_rgba(0,0,0,0.3)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.3),inset_0_-1px_0_rgba(0,0,0,0.5)] transition-all active:translate-y-0.5 active:shadow-[inset_0_1px_0_rgba(0,0,0,0.3)]",

  // Полная ширина кнопка
  buttonFull: "w-full px-3 py-1.5 bg-gradient-to-b from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white font-bold rounded-none border-2 border-amber-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.3),inset_0_-1px_0_rgba(0,0,0,0.3)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.3),inset_0_-1px_0_rgba(0,0,0,0.5)] transition-all active:translate-y-0.5 active:shadow-[inset_0_1px_0_rgba(0,0,0,0.3)]",

  // Полная ширина кнопка с уменьшенной непрозрачностью (для вторичных действий)
  buttonSecondary:
    "w-full px-3 py-1.5 bg-gradient-to-b from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white font-bold rounded-none border-2 border-amber-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.3),inset_0_-1px_0_rgba(0,0,0,0.3)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.3),inset_0_-1px_0_rgba(0,0,0,0.5)] transition-all active:translate-y-0.5 active:shadow-[inset_0_1px_0_rgba(0,0,0,0.3)] opacity-80 hover:opacity-100",

  // Переключатель языка
  languageToggle: "flex bg-amber-600 rounded-full overflow-hidden shadow-lg",
  languageButton:
    "px-4 py-2 text-sm font-semibold transition-all {{isActive}}",
  languageButtonActive: "bg-amber-800 text-white",
  languageButtonInactive: "bg-amber-600 text-amber-100 hover:bg-amber-700",

  // Шрифт для всех модалов
  fontFamily: "MinecraftGeorgian, monospace",

  // Контейнер для правил/списка
  rulesList: "space-y-3 text-amber-900 text-sm sm:text-base mb-6 max-h-48 sm:max-h-64 overflow-y-auto",

  // Элемент списка правил
  ruleItem: "flex items-start gap-3",

  // Номер правила
  ruleNumber: "text-amber-700 font-bold flex-shrink-0 text-lg",

  // Сообщение в модальном окне
  message: "text-amber-900 text-base sm:text-lg mb-8 text-center whitespace-pre-wrap",

  // Контейнер для кнопок
  buttonContainer: "flex flex-col gap-4",

  // Контейнер для двух кнопок
  buttonGroupTwo: "flex flex-col sm:flex-row gap-4",

  // Контейнер для трех кнопок
  buttonGroupThree: "flex flex-col gap-4",

  // Контейнер для кнопок с flex-1
  buttonFlex: "flex-1",
};
